module.exports = __webpack_public_path__ + "img/Blog-Image.b6f900f3.png";